import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  fetchUserByUUIDLoading: false,
  fetchUserByUUIDError: '',
  userDetails: null,
  createUserLoading: false,
  createUserError: '',
  createCorpLoading: false,
  createCorpError: '',
  redirect: '',
};

export const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    fetchUserByUUIDRequest: (state) => {
      state.fetchUserByUUIDLoading = true;
    },
    fetchUserByUUIDSuccess: (state, {payload}) => {
      state.fetchUserByUUIDLoading = false;
      state.userDetails = payload;
      state.fetchUserByUUIDError = '';
    },
    fetchUserByUUIDError: (state, {payload}) => {
      state.fetchUserByUUIDLoading = false;
      state.fetchUserByUUIDError = payload;
    },
    createUserRequest: (state) => {
      state.createUserLoading = true;
    },
    createUserSuccess: (state) => {
      state.createUserLoading = false;
      state.createUserError = '';
    },
    createUserError: (state, {payload}) => {
      state.createUserLoading = false;
      state.createUserError = payload;
    },
    setRedirect: (state, {payload}) => {
      state.redirect = payload;
    },
    createCorporateRequest: (state) => {
      state.createCorpLoading = true;
    },
    createCorporateSuccess: (state) => {
      state.createCorpLoading = false;
      state.createCorpError = '';
    },
    createCorporateError: (state, {payload}) => {
      state.createCorpLoading = false;
      state.createCorpError = payload;
    },
  },
});

export const {
  fetchUserByUUIDRequest,
  fetchUserByUUIDSuccess,
  fetchUserByUUIDError,
  createUserRequest,
  createUserSuccess,
  createUserError,
  setRedirect,
  createCorporateRequest,
  createCorporateSuccess,
  createCorporateError,
} = registerSlice.actions;

export default registerSlice.reducer;
